module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/logo-5b31f50a7cf956fe02af192dcb46e138.png";